import intlTelInput from 'intl-tel-input';

function initializePhoneInput(inputElement, strictMode = false) {
  if (!inputElement) {
    return;
  }
  
  intlTelInput(inputElement, {
    initialCountry: 'us',
    strictMode: strictMode,
    loadUtils: () => import('./intlTelInputUtils.js'),
  });
}

window.initializePhoneInput = initializePhoneInput;
